/* RESPONSIBLE TEAM: team-automation-foundations */
import type ApplyConversationSla from 'embercom/models/operator/visual-builder/step/apply-conversation-sla';
import StepConfig, { type StepConfigParams } from '../step';

export default class ApplyConversationSlaConfiguration extends StepConfig {
  declare step: ApplyConversationSla;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/apply-conversation-sla',
      ...params,
    });
  }
}
